import { inject, Injectable } from '@angular/core';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { interval, Observable } from 'rxjs';

@Injectable()
export class SwUpdateService {

  private swUpdate = inject(SwUpdate)

  constructor() {
    if (!this.swUpdate.isEnabled) {
      console.log('SwUpdate isEnabled: Nope 🙁');
    }
  }

  monitorServiceWorkerUpdate(): Observable<VersionEvent> {
    return this.swUpdate.versionUpdates;
  }

  setupServiceWorker(): void {
    if (this.swUpdate.isEnabled) {
      // Service worker is enabled
      // Check for update
      interval(1000 * 60 * 0.5).subscribe(() => {
        this.swUpdate.checkForUpdate();
      });
    }
  }
}
